define('modules/profiles/main/profile.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("ProfileApp.Main", function(Main, Prospector, Backbone, Marionette, $, _){
        Main.Controller = {
            loadProfile: function(identityType, sourceId, refId, options){
                require(["modules/profiles/main/views/profile.view"],
                    function(ProfileView){
                        document.getElementsByTagName('title')[0].innerHTML = 'Profile Page - RelPro &reg;';
                        var profileView = new ProfileView({
                            identityType: identityType,
                            sourceId: sourceId,
                            refId: refId,
                            drawer: options != undefined && options.drawer != undefined ? options.drawer : undefined,
                            request: options != undefined && options.request != undefined ? options.request : undefined
                        });
                        Prospector.trigger("closeHistoryDrawer");
                        Prospector.trigger('closeSideDrawer');

                        Prospector.mainRegion.show(profileView);
                    });
            }
        }
    });
    return Prospector.ProfileApp.Main.Controller;
});
